import { Box } from "@mui/system";
import { StudyFilter } from "./study-filter/StudyFilter";
import { OpenInViewer } from "./open-in-viewer/OpenInViewer";
import { EzyvetDataEntry } from "./ezyvet-interface/EzyvetPopup";
import { XcaliberDataEntry } from "./xcaliber-interface/XcaliberPopup";
import { useUserType } from "hooks/useUserType";
import { USER_TYPES } from "consts";

export const StudyTableControls = () => {
  const { userType } = useUserType();
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        margin: "1rem",
        width: "100%",
        gap: "1rem",
        paddingLeft: "0.3rem",
      }}
    >
      <StudyFilter />
      <OpenInViewer />
      {userType === USER_TYPES.ADMIN || userType === USER_TYPES.DEVELOPER ? 
        <>
        <EzyvetDataEntry/> 
        <XcaliberDataEntry/>
        </>
      :
        <></>
      }
    </Box>
  );
};
